import { supabase } from "@/integrations/supabase/client";

export const publicUrl = (path: string | null | undefined) => {
  if (!path) return null;
  return supabase.storage.from("media").getPublicUrl(path).data.publicUrl;
};

export const uploadMedia = async (file: File, prefix: string) => {
  const ext = file.name.split(".").pop() ?? "jpg";
  const path = `${prefix}/${Date.now()}-${Math.random().toString(36).slice(2, 8)}.${ext}`;
  const { error } = await supabase.storage.from("media").upload(path, file, {
    cacheControl: "3600",
    upsert: false,
  });
  if (error) throw error;
  return path;
};
